import { Link } from '@cian/ui-kit/link';

import type { ICommercialLink } from 'shared/types/commercialLinks';

import style from './style.css';

export interface ICommercialSubmenuProps {
  links: ICommercialLink[];
}

export const CommercialSubmenu = ({ links }: ICommercialSubmenuProps) => {
  if (!links.length) {
    return null;
  }

  return (
    <nav className={style['container']} data-name="CommercialSubmenu">
      <div className={style['links']}>
        {links.map(({ type, title, url }) => (
          <Link key={type} href={url} fontSize="S">
            {title}
          </Link>
        ))}
      </div>
    </nav>
  );
};
